import { sortOptions } from "@/utils/software";
import type { SortKey } from "@/utils/software";

interface Props {
  value: SortKey;
  onChange: (key: SortKey) => void;
}

export default function SortTabs({ value, onChange }: Props) {
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
      {sortOptions.map((opt) => (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
            value === opt.key
              ? "bg-primary-500 text-foreground-950"
              : "text-foreground-600 hover:text-primary-700"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}